import { INVOICEID_NO_INVOICE, Charge } from 'lane-shared/domains/billingPayments/types';
import { isManagedInvoiceStatus } from 'domains/billingAndPayments/invoiceBilling/invoiceStatusPresentation';

export function showServiceRequestChargeStatus(
    isWOInvoicingOptionsFFEnabled: boolean,
    isBPInvoicingDisabled: boolean,
    isSRInvoiceOptionsEnabled: boolean | undefined,
    { charge, isBilledStatusEnabled }: { charge: Charge; isBilledStatusEnabled?: boolean },
): boolean {
    const isManaged = isManagedInvoiceStatus(
        charge.invoice?.status ?? '',
        Boolean(isBilledStatusEnabled),
    );

    if (!isWOInvoicingOptionsFFEnabled) {
        if (charge.status === 'VOIDED') return true;

        if (isManaged) return false;

        return true;
    }

    if (charge.status === 'VOIDED') return true;

    if (isManaged) return false;

    if (isBPInvoicingDisabled) return false;

    if (isSRInvoiceOptionsEnabled !== undefined && !isSRInvoiceOptionsEnabled) return false;

    return charge.invoiceId !== INVOICEID_NO_INVOICE;
}